// object -> its Matreshka definition (events, props, id)
export default new WeakMap();